import { Component, EventEmitter, inject, Output, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { InputGala } from '@composants/index';
import { Client, ClientsService } from '@estel-numerique/galaclick-api';
import { UtilService } from '@services/index';
import { lastValueFrom } from 'rxjs';
import { DialogGalaComponent } from '../composants/dialog-gala/dialog-gala.component';
import { InputGala as InputGala_1 } from '../composants/inputs/input.component';
import { InputNumericDirective } from '../directive/input-numeric.directive';
import { FormsModule } from '@angular/forms';
import { MenuClientComponent } from '../composants/menu-context/menu-client/menu-client.component';
import { MatButton } from '@angular/material/button';

export interface RechClientComponentData {
    isUpload?: boolean
}
@Component({
    templateUrl: './rech-client.component.html',
    imports: [DialogGalaComponent, InputGala_1, InputNumericDirective, FormsModule, MenuClientComponent, MatButton]
})
export class RechClientComponent {
    protected readonly util = inject(UtilService);
    protected readonly servClient = inject(ClientsService);
    protected readonly dialogRef = inject(MatDialogRef<RechClientComponent>);
    protected readonly data = inject<RechClientComponentData>(MAT_DIALOG_DATA);

    protected nuchep: string = null;
    private lastRecherche: string;
    protected client: Client;
    protected isUpload: boolean;
    protected titre: string;

    // eslint-disable-next-line @angular-eslint/no-output-native
    @Output() close: EventEmitter<string> = new EventEmitter<string>();
    @ViewChild('inputNuchep') inputNuchep: InputGala;

    constructor() {
        this.isUpload = this.data?.isUpload;
        this.titre = this.isUpload ? "Chargement fichier labo - Sélection numéro cheptel" : "Client - Accès rapide";
        this.dialogRef.updateSize('600px');
    }

    protected async changeInput() {
        try {
            if (this.nuchep.length < 8) {
                this.client = null;
                this.lastRecherche = null;
                return;
            }
            if (this.lastRecherche !== this.nuchep) {
                this.util.showLoader();
                this.client = await lastValueFrom(this.servClient.getClientByNuchep(this.nuchep));
                this.lastRecherche = this.nuchep;
                if (!this.client) {
                    this.util.showToastError(`Client ${this.nuchep} inconnu`);
                }
            }
        } catch (e) {
            this.util.fErreur(e);
        } finally {
            this.util.hideLoader();
        }
    }

    public hideModal() {
        if (this.nuchep && this.client) {
            this.close.emit(this.nuchep);
        }
        this.dialogRef.close();
    }

    protected focusElem() {
        setTimeout(() => this.inputNuchep.setFocus(), 100);
    }
}
